import React, { useEffect, useRef } from "react";
import { useState } from "react";
import DashboardIcon from "../../assets/images/DashboardIcon";
import StafflistIcon from "../../assets/images/StafflistIcon";
import ApplicationManagementIcon from "../../assets/images/ApplicationManagement";
import RolesPermissionIcon from "../../assets/images/RolesPermissionIcon";
import ReportsIcon from "../../assets/images/ReportsIcon";
import HelpIcon from "../../assets/images/HelpIcon";
import SettingsIcon from "../../assets/images/SettingsIcon";
import {
  MenuItems,
  pageRouteConstants,
} from "../../constants/constants";
import {  useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../store/store";
import { updateIndex } from "../../store/slices/sideMenuSlice";

import "./SideMenu.css";
import LocationMasterIcon from "../../assets/images/LocationMasterIcon";
import SideMenuWeb from "./SideMenuWeb";
import { resetKey } from "../../store/slices/staffListSlice";
export const componentMap: Record<string, React.ComponentType<any>> = {
  Dashboard: DashboardIcon,
  "Employee List": StafflistIcon,
  "User Groups": StafflistIcon,
  Applications: ApplicationManagementIcon,
  "User Roles": RolesPermissionIcon,
  Reports: ReportsIcon,
  Location: LocationMasterIcon,
  Help: HelpIcon,
  Setting: SettingsIcon,
};
export const sideMenuIndexData: any = {
  "#/dashboard": 0,
  "#/stafflist": 1,
  "#/locationMaster": 5,
  "#/help": 6, 
};
const SideMenu = (props: any) => {
  const dispatch = useDispatch<AppDispatch>();

  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  useEffect(() => {}, []);
  const navigate = useNavigate();
  const handleClick = (index: number) => {
    switch (index) {
      case 0:
        navigate(pageRouteConstants.dashBoardRoute);
        break;
      case 1:
        navigate(pageRouteConstants.staffListRoute);
        break;
      case 5:
        navigate(pageRouteConstants.locationMaster);
        break;
      case 6:
        navigate(pageRouteConstants.helpRoute);
        break;
      default:
        navigate(pageRouteConstants.comingSoonRoute);
    }
  };
  const sideMenuIndex = useSelector(
    (state: RootState) => state.sideMenuDetails?.index
  );
  const lastUpdated = useSelector(
    (state: RootState) => state.sideMenuDetails?.lastUpdated
  );
  const [selectedMenu, setSelectedMenu] = useState(sideMenuIndex);
  const sideMenu = MenuItems;
  const menuRef = useRef<any>(null);
  const [sliderOpen, setSliderOpen] = useState(false);

  const closeSlider = () => {
    setSliderOpen(false);
  };
  const openSlider = () => {
    setSliderOpen(true);
    menuRef!.current.style.width = "256px";
  };
  const handleChange = (index: number) => {
    console.log("handleChange called with index:", index);
    dispatch(updateIndex(index));
    dispatch(resetKey());
    handleClick(index); 
  };


  useEffect(() => {
    let index = sideMenuIndex;
    
    if (sideMenuIndexData[window.location.hash] !== undefined) {
      index = sideMenuIndexData[window.location.hash];
    }
    
    setSelectedMenu(index);
    if (index !== selectedMenu) {
      handleClick(index);
    }
  }, [sideMenuIndex, lastUpdated]);

  useEffect(() => {
    if (sliderOpen === true) {
      menuRef!.current.style.width = "256px";
    } else {
      menuRef!.current.style.width = "81px";
    }
  }, [sliderOpen]);

  return (
    <>
      <div className=" hidden md:block">
        <SideMenuWeb
          menuItems={sideMenu}
          selectedMenuIndex={selectedMenu}
          componentMap={componentMap}
          openModal={openModal}
          closeModal={closeModal}
          isSlideerOpen={sliderOpen}
          openSlider={openSlider}
          closeSlider={closeSlider}
          handleChange={handleChange}
          isModalOpen={isModalOpen}
          menuRef={menuRef}
        />
      </div>

      {/* Mobile View */}
      <div className="block md:hidden">
     
      </div>
    </>
  );
};
export default SideMenu;
